// Conductor-specific palette. The platform design system has no orange accent
// and no tinted glyph colors, so these one-off values live here as a single
// source of truth. They're applied via inline `style` (not Tailwind arbitrary
// classes) because Tailwind's JIT can't see values interpolated from JS.

export const ACCENT = "#ea580c";
export const ACCENT_BORDER_TINT = "rgba(234, 88, 12, 0.3)";
export const ACCENT_BG_TINT = "rgba(234, 88, 12, 0.1)";

// Step-kind glyph tints (10% backgrounds), matching the design's blue/violet.
export const BLUEPRINT_GLYPH = { color: "#0284c7", backgroundColor: "rgba(2, 132, 199, 0.1)" };
export const PLAN_GLYPH = { color: "#7c3aed", backgroundColor: "rgba(124, 58, 237, 0.1)" };
